module.exports = __webpack_public_path__ + "img/notifications.ebd5842b.svg";